//============================================================================
// Name        : rfid_print.ts
// Purpose     : Implement regular RFID Print page
// Created     : 2018-07-10

// Copyright   : Copyright 2018 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../index";

class RfidPrintR2 {
    init() {
        // Initialize remember reader functionality
        $("#print_r2_printer_id").on("change", (e) => {
            axios.get(`save_selected_printer.json`, { params: { id: $(e.target).val() } });
        });

        $(".btn_print_r2").on("click", (e) => {
            $(e.target).prop("disabled", true);
        });
    }
}

export function LoadPage() {
    InitPage("rfids print_r2", () => {
        const rfid = new RfidPrintR2();
        rfid.init();
    });
}
